const MONSKIT_CODES = 'scratch-gui/navigation/MONSKIT_CODES';


let INITIAL_CODE = ''

const initialState = {
    monskitGeneratedCodes: INITIAL_CODE
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case MONSKIT_CODES:
        return action.monskitGeneratedCodes

    default:
        return state;
    }
};

const changeMonskitGeneratedCodes = function (code) {
    console.log(code)
    // 생성된 코드
    return {
        type: MONSKIT_CODES,
        monskitGeneratedCodes: code
    };
};

export {
    reducer as default,
    initialState as monskitGeneratedCodesInitialState,
    changeMonskitGeneratedCodes,
};
